/*!
 * Copyright © 2020-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EApiRequestStatus } from '../../models';

export interface IUserState {
  username: string;
  password: string;
  sessionToken: string;
  verificationAttempts: number;
  resendAttempts: number;
  setPasswordRequestStatus: EApiRequestStatus;
  resendCodeRequestStatus: EApiRequestStatus;
  verifyAccountRequestStatus: EApiRequestStatus;
}

export const initialUserState: IUserState = {
  username: '',
  password: '',
  sessionToken: '',
  verificationAttempts: 0,
  resendAttempts: 0,
  setPasswordRequestStatus: EApiRequestStatus.Initial,
  resendCodeRequestStatus: EApiRequestStatus.Initial,
  verifyAccountRequestStatus: EApiRequestStatus.Initial,
};
